/**
 * Utility for sending events to Google Tag Manager dataLayer
 * Google Analytics configuration is done in the GTM interface
 */

/**
 * Checks if dataLayer is available
 */
export const isDataLayerAvailable = (): boolean => {
  return typeof window !== 'undefined' && Array.isArray(window.dataLayer)
}

/**
 * Sends an event to GTM dataLayer
 * @param eventName - Event name (e.g., 'search')
 * @param eventParams - Event parameters
 */
export const sendGTMEvent = ({
  eventName,
  eventParams,
}: {
  eventName: string
  eventParams?: Record<string, unknown>
}): void => {
  if (!isDataLayerAvailable()) return

  try {
    window.dataLayer.push({
      event: eventName,
      ...eventParams,
    })
  } catch (error) {
    console.error('Failed to send GTM event:', error)
  }
}
